import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { useCounter } from '../hooks/useCounter'

const sectorMeta = {
  'Engineering':          { icon: 'fas fa-gears' },
  'Health Care':          { icon: 'fas fa-stethoscope' },
  'Finance':              { icon: 'fas fa-chart-line' },
  'Communications':       { icon: 'fas fa-bullhorn' },
  'Transport':            { icon: 'fas fa-truck' },
  'Property':             { icon: 'fas fa-building' },
  'Security':             { icon: 'fas fa-shield-halved' },
  'Hospitality':          { icon: 'fas fa-concierge-bell' },
  'Project Mgmt':         { icon: 'fas fa-list-check' },
  'Administration':       { icon: 'fas fa-folder-open' },
  'Skilled Trades':       { icon: 'fas fa-screwdriver-wrench' },
  'Technology':           { icon: 'fas fa-microchip' },
  'Construction':         { icon: 'fas fa-helmet-safety' },
  'Manufacturing':        { icon: 'fas fa-industry' },
  'Retail':               { icon: 'fas fa-bag-shopping' },
  'Education':            { icon: 'fas fa-graduation-cap' },
  'Agriculture':          { icon: 'fas fa-seedling' },
  'Professional Services':{ icon: 'fas fa-briefcase' },
}

const Hero = () => {
  const { ref: heroRef, isVisible } = useScrollAnimation()

  const counters = [
    { id: 1, value: 15, suffix: '+', label: 'Years Experience' },
    { id: 2, value: 15, suffix: '+', label: 'Industries Covered' },
    { id: 3, value: 100, suffix: '%', label: 'NZ Focused' }
  ]

  return (
    <section id="hero" ref={heroRef} className={`hero ${isVisible ? 'visible' : ''}`}>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">Matching Top Talent with Exceptional Kiwi Employers</div>
            <h1 className="hero-title">
              Guiding you to meaningful career opportunities across{' '}
              <span className="gradient-text">Aotearoa</span>
            </h1>
            <p className="hero-subtext">
              TalentHouse is your trusted recruitment partner, connecting skilled professionals with leading employers across Aotearoa. We don't just go beyond simply filling roles, we identify candidates who are not only highly skilled and competent, but also the perfect cultural fit for your organisation.
            </p>
            <div className="hero-buttons">
              <a href="#jobs" className="btn btn-primary btn-large">
                <i className="fas fa-search"></i>
                Browse Jobs
              </a>
              <a href="#contact" className="btn btn-outline-white btn-large">
                <i className="fas fa-phone"></i>
                Contact Us
              </a>
            </div>
            <div className="hero-stats">
              {counters.map((counter) => (
                <div key={counter.id} className="stat-item">
                  <div className="stat-number">
                    <Counter value={counter.value} suffix={counter.suffix} isVisible={isVisible} />
                  </div>
                  <div className="stat-label">{counter.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

// Counter Component
const Counter = ({ value, suffix, isVisible, delay }) => {
  const count = useCounter(value, isVisible, delay)

  return (
    <>{count.toLocaleString()}{suffix}</>
  )
}

export default Hero
